import { cn } from '@Utils/cn';

import FieldShell from './FieldShell';

export interface SegmentedOption {
  value: string;
  label: string;
}

interface SegmentedFieldProps {
  title?: string;
  description?: string;
  options: SegmentedOption[];
  value?: string;
  onChange: (value: string) => void;
}

/** Joined row of buttons with exactly one selected (enum ≤ 4 options). */
export default function SegmentedField({
  title,
  description,
  options,
  value,
  onChange,
}: SegmentedFieldProps) {
  return (
    <FieldShell title={title} description={description}>
      <div className="flex w-full overflow-hidden rounded-lg border border-gray-200">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              'grow border-r border-gray-200 px-3 py-1.5 text-sm text-zinc-600 last:border-r-0 hover:bg-zinc-50',
              value === option.value && 'bg-zinc-100 font-medium text-zinc-900',
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </FieldShell>
  );
}
